
<div *ngIf="countdown$ | async as countdown">

  <div *ngIf="adminControl.value === false">
    <p  style="padding: 0 16px "> Przerwa techniczna za {{ countdown }}</p>
   </div>

   <div *ngIf="adminControl.value === true">
     <p  style="padding: 0 16px "> Aktywna blokada logowania użytkowników. Przewidywany czas niedostępności systemu {{ countdown }}</p>
   </div>


</div>
